import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useState, useEffect } from 'react';

function useStickyHeader(enabled, querySelector, stickCallback, unstickCallback, stickyHeaderOffset, stickyHeaderZIndex) {
  var originalTop = useRef(null);
  var originalWidth = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSticky = _useState2[0];
    _useState2[1];
  useEffect(function () {
    if (isSticky) {
      stickCallback && stickCallback();
    } else {
      unstickCallback && unstickCallback();
    }
  }, [isSticky]);
  useEffect(function () {
    var handleResize = function handleResize() {
      var element = document.querySelector(querySelector);
      var body = document.querySelector('.ag-body-viewport');
      element.style.width = "".concat(body.getBoundingClientRect().width, "px");
    };
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(function () {
    var handleScroll = function handleScroll(ev) {
      if (!enabled) {
        return;
      }
      var element = document.querySelector(querySelector);
      var body = document.querySelector('.ag-body-viewport');
      if (originalTop.current === null) {
        originalTop.current = element.getBoundingClientRect().top + window.scrollY;
      }
      if (originalWidth.current === null) {
        originalWidth.current = element.getBoundingClientRect().width;
      }
      if (window.scrollY + stickyHeaderOffset >= originalTop.current) {
        element.style.position = 'fixed';
        element.style.zIndex = stickyHeaderZIndex || '500';
        element.style.top = "".concat(stickyHeaderOffset, "px");
        // element.style.width = `${originalWidth.current}px`;
        element.style.width = "".concat(body.getBoundingClientRect().width, "px");
        body.style.marginTop = "".concat(element.getBoundingClientRect().height, "px");
      } else {
        element.style.position = 'relative';
        element.style.top = '0';
        body.style.marginTop = '0';
      }
    };
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return true;
}

export { useStickyHeader };
